
import {
    mapState,
    mapActions,
} from 'vuex'
// import _ from 'lodash'
import viewName from '../constant.js'
import { NoticeBar, SubmitBar, CountDown, Dialog, ActionSheet, Tag } from 'vant'
import guideFloating from '../../components/guideFloating/guideFloating.vue'
import CouponInfo from '../../components/couponInfo/couponInfo.vue'
import appGuideDialog from '../../components/appGuideDialog/appGuideDialog.vue'
import { isWx } from '../../utils/ua'
// import { getLocalConfig } from '../../utils/session'
import { wxShare } from '../../utils/wxsdk'
import {
    getMarketingActivities,
    // createOrder,
    getCouponList
} from '../../models/marketingActivities'
import SectionTitle from '../../components/sectionTitle/sectionTitle.vue'
import {
    getCoupon
} from '@/models/coupon'

export default {
    name: viewName.marketingActivities,
    inject: ['showLoading', 'hideLoading'],
    components: {
        SectionTitle,
        guideFloating,
        appGuideDialog,
        CouponInfo,
        [NoticeBar.name]: NoticeBar,
        [SubmitBar.name]: SubmitBar,
        [CountDown.name]: CountDown,
        [Dialog.name]: Dialog,
        [ActionSheet.name]: ActionSheet,
        [Tag.name]: Tag,
    },
    data () {
        return {
            activity_title: '', // 营销活动标题
            activity_banner: '', // 营销活动模板主图
            // 活动状态, 0: 活动未开始，1：活动进行中， 2：活动已结束或者活动下架, 3： 页面失效
            activity_status: 0,
            // 活动时间，单位毫秒
            activity_time: {
                no_start: 0, // 活动未开始之前的时间
                end: 0 // 活动结束时间
            },
            activity_time_color: '', // 倒计时字体颜色
            activity_time_background_color: '', // 倒计时背景颜色
            activity_time_background_img: '', // 倒计时背景颜色图片
            show_color_or_img: 1, // 判断显示倒计时背景颜色还是倒计时背景图片, 1: 图片, 2: 颜色
            activity_store_num: 0, // 活动剩余商品数量
            is_show_store_num: false, // 是否显示剩余商品数量，true:显示. false：不显示
            sstore_name: '', // 门店名称
            sstore_address: '', // 门店地址
            sstore_tel: '', // 门店电话
            // 活动内容
            activity_content: {
                price: '', // 原价
                is_show_price: false, // 是否显示原价, ture: 显示， false: 不显示
                total_price: '', // 总价
                // 服务列表
                services: []
            },
            activity_explan: '', // 活动介绍
            activity_explan_imgs: [], // 活动介绍图片
            buy_notes: '', // 购买须知
            buy_notes_imgs: [], // 购买须知图片
            show_buy_notes: false, // 是否显示购买须知, ture: 显示， false: 不显示
            purchase_count: 0, // 限购数量, 没有则返回0
            indate: '', // 有效期
            is_overstep_buy: false, // 是否超出限购次数，ture：超出，false: 不超出
            // 门店地理坐标
            lng: '', // 经度
            lat: '', // 纬度
            share: {
                title: '', // 分享标题
                desc: '', // 分享描述
                imgUrl: '' // 分享图片
            },
            page_background_color: '', // 页面背景颜色
            text_color: '', // 标题和内容文字颜色
            content_background_color: '', // 内容背景颜色
            showDialog: false,
            package_id: '', // 营销活动id
            sstore_id: '', // 门店id
            distribution_code: '', // 标识码
            isWx: isWx(),
            showPage: false,
            showNoContent: false,
            floatBtnList: [{key: 'app_download', top: '69'}, {key: 'top', top: '76.5'}],
            btnLoading: false,
            couponList: {
                can_coupon_list: [],
                has_coupon_list: [],
            },
            bc_coupon: [], // 优惠券标签
            show: false,
            jumpSmallWeChatParams: {
                user_receive_coupon_id: '',
                coupon_id: '',
                sstore_id: '',
                coupon_type: '',
                is_details: ''
            }
        }
    },
    filters: {
        addZero (value) {
            return value > 9 ? value : `0${value}`
        },
        getPreText (value) {
            return value === 0 ? '还有'
                : value === 1 ? '剩' : ''
        },
        getAfterText (value) {
            return value === 0 ? '开始'
                : value === 1 ? '结束' : ''
        }
    },
    computed: {
        ...mapState({
            token: ({ appInfo }) => appInfo.token || appInfo.wxUserInfo.token || ''
        }),
        time () {
            return this.activity_status === 0 ? this.activity_time.no_start
                : this.activity_status === 1 ? this.activity_time.end : 0
        },
        btnText () {
            let text = '立即抢购'
            if (this.activity_status === 0) {
                // 活动未开始 => 立即抢购
            } else if (this.activity_status === 1) {
                // 活动进行中, 有库存 => 立即抢购, 没库存 => 已售罄
                if (this.activity_store_num === 0) {
                    text = '已售罄'
                }
            } else {
                text = '活动已结束'
            }
            return text
        },
        btnDisabled () {
            let flag = false
            if (this.activity_status === 0) {
                // 活动未开始 => 不可点击
                flag = true
            } else if (this.activity_status === 1) {
                // 活动进行中, 有库存 => 立即抢购, 没库存 => 已售罄
                if (this.activity_store_num === 0) {
                    flag = true
                }
                // 是否超出限购次数
                if (this.is_overstep_buy) {
                    flag = true
                }
            } else {
                flag = true
            }
            return flag
        },
        overstep () {
            let status = false
            // 活动进行中
            if (this.activity_status === 1) {
                // 是否超出限购次数
                if (this.is_overstep_buy) {
                    status = true
                }
            }
            return status
        }
    },
    created () {
        // const code = this.$route.query.code || getLocalConfig('code') || ''
        // if (this.isWx && code) {
        //     // 调取，用于通过code获取用户信息并且保存到本地
        //     this.getWxUserInfo(code).then(() => {
        //         // 删除链接上的code,以免分享出去
        //         const path = this.$route.path
        //         const query = _.cloneDeep(this.$route.query)
        //         query['code'] && delete query['code'] && this.$router.replace({ path, query })
        //     })
        // }
    },
    activated () {
        const { package_id, sstore_id, distribution_code } = this.$route.query
        this.package_id = package_id
        this.sstore_id = sstore_id
        this.distribution_code = distribution_code
        this.getMarketingActivitiesDatas()
    },
    mounted () {

    },
    methods: {
        ...mapActions([
            'setAppClass',
            'verifyUserInfo',
            'getWxUserInfo'
        ]),
        // 设置微信分享
        configWXShare () {
            const share = Object.assign({}, this.share, {link: window.location.href})
            wxShare(share)
        },
        // 显示引导关注/下载 弹窗
        showModal () {
            this.$refs.appGuideDialog.showStatus = true
        },
        // 获取营销活动数据
        async getMarketingActivitiesDatas () {
            try {
                this.showLoading()
                const data = await getMarketingActivities({package_id: this.package_id, sstore_id: this.sstore_id, distribution_code: this.distribution_code})
                data.activity_explan = data.activity_explan.replace(/\r\n|\n|\r/g, '<br />')
                data.buy_notes = data.buy_notes.replace(/\r\n|\n|\r/g, '<br />')
                Object.assign(this, data)
                this.isWx && this.configWXShare()
                this.$emit('setHeader', {
                    title: this.activity_title || '营销活动详情',
                    showHeader: true,
                    showLeft: true
                })
                if (this.activity_status === 2) {
                    this.showNoContent = true
                } else if (this.activity_status === 3) {
                    Dialog.alert({
                        message: '活动已失效，无法购买',
                        confirmButtonText: '我知道了',
                        confirmButtonColor: '#fc2d2d'
                    }).then(() => {
                        // 显示APP下载引导弹窗
                        this.showModal()
                    })
                } else {
                    this.showPage = true
                }
                this.setAppClass({
                    isAppend: true,
                    className: this.activity_status === 3 ? 'bgGreyColor' : 'bgWhiteColor'
                })
                this.hideLoading()
            } catch (err) {
                this.hideLoading()
            }
        },
        // 倒计时结束时触发
        onFinish () {
            if (this.activity_status === 0) {
                this.activity_status = 1
                this.activity_time.no_start = 0
            } else if (this.activity_status === 1) {
                this.activity_status = 2
                this.activity_time.end = 0
            }
        },
        showTelDialog () {
            this.showDialog = true
        },
        closeTelDialog () {
            this.showDialog = false
        },
        // 点击导航去门店
        goMap () {
            window.location.href = `https://api.map.baidu.com/marker?location=${this.lat},${this.lng}&title=${this.sstore_name}&content=${this.sstore_address}&output=html&src=webapp.baidu.openAPIdemo`
        },

        // 下单
        async placeAnOrder () {
            this.btnLoading = true
            try {
                // this.showLoading()
                // const data = await createOrder({package_id: this.package_id, sstore_id: this.sstore_id, distribution_code: this.distribution_code})
                // this.hideLoading()
                // 跳转营销活动确认订单页面
                this.$router.push({
                    path: '/marketingConfirmOrder',
                    query: {
                        // order_id: data.order_id,
                        package_id: this.package_id,
                        sstore_id: this.sstore_id,
                        distribution_code: this.distribution_code
                    }
                })
                this.btnLoading = false
            } catch (err) {
                // this.hideLoading()
                this.btnLoading = false
                const code = err.errcode
                // 9101:活动已失效，无法购买, 9102: 来慢了~该活动已售罄
                if (code === 9101 || code === 9102) {
                    Dialog.alert({
                        message: code === 9102 ? '来慢了~该活动已售罄' : '活动已失效，无法购买',
                        confirmButtonText: '我知道了'
                    }).then(() => {
                        if (code === 9102) {
                            // 重新请求当前页面数据
                            this.getMarketingActivitiesDatas()
                        } else  {
                            // 显示APP下载引导弹窗
                            this.$refs.appGuideDialog.showStatus = true
                        }
                    })
                }
            }
        },

        // 立即购买
        onSubmit () {
            // 超出限购次数
            if (this.overstep) {
                this.$toast('已达到购买上限，不可继续购买')
            } else {
                this.verifyUserInfo().then(() => {
                    this.placeAnOrder()
                })
            }
        },
        showTips (coupon) {
            Object.assign(this.jumpSmallWeChatParams, {
                user_receive_coupon_id: coupon.user_receive_coupon_id,
                coupon_id: coupon.coupon_id,
                sstore_id: this.sstore_id,
                wechat_sstore_id: coupon.wechat_sstore_id,
                coupon_type: coupon.type === 'bc' ? '1' : '2',
                is_details: '1'
            })
            this.$refs.appGuideDialog.open()
        },
        openCouponList () {
            this.getCouponList()
        },
        /**
         * 请求优惠券列表数据
         */
        getCouponList () {
            this.showLoading()
            getCouponList({
                package_id: this.package_id,
                sstore_id: this.sstore_id
            }).then(res => {
                this.hideLoading()
                const can_coupon_lis = res.can_coupon_list.map((item) => {
                    item.is_get = 0
                    return item
                })
                const has_coupon_list = res.has_coupon_list.map((item) => {
                    item.is_get = 1
                    return item
                })

                res.can_coupon_list = can_coupon_lis
                res.has_coupon_list = has_coupon_list
                this.couponList = res
            }).catch(err => {
                this.hideLoading()
                console.log(err)
            })
        },
        // 领取优惠券
        clickGetCoupon (coupon) {
            this.verifyUserInfo({
                type: 'back'
            }).then(_ => {
                this.showLoading()
                getCoupon({
                    coupon_id: coupon.coupon_id,
                    type: coupon.type
                }).then(res => {
                    this.hideLoading()
                    this.$toast('领取成功')
                    this.getCouponList()
                }).catch(err => {
                    this.hideLoading()
                    console.log(err)
                })
            })
        },
    },
    destroyed () {

    },
}
